export const StationRiskMock = {
  data: {
    devices: [
      {
        deviceId: '285a8c7a-d89b-48d1-a87f-c6b72c55ce32',
        deviceName: '#2 - RS200ne',
        flowDegradation: 0,
        noDegradationReason: 'compressor did not reach maximum variable speed',
        maxFlow: 37,
        status: 'active',
      },
      {
        deviceId: 'f58bc1e6-4cdd-49e1-80ef-f50db6449d09',
        deviceName: '#1 - RS200ne',
        flowDegradation: 0,
        noDegradationReason: 'compressor did not reach maximum variable speed',
        maxFlow: 37,
        status: 'active',
      },
    ],
    peakSupplyFlow: 51.26521306041508,
  },
};

export const StationCapacityMockData = {
  isRealtimeAboveMaxAvailable: false,
  newRealtimePosition: 55.34189189189189,
  realtimePosition: 55.34189189189189,
  isOverlapping: false,
  newPeakPosition: 69.27731494650686,
  peakSupplyFlowPosition: 69.27731494650686,
  newMaxPosition: 100,
  maxAvailablePosition: 100,
};
